export default __webpack_public_path__ + "static/media/logo5.b8d8aa20.webp";